import { Capacitor } from '@capacitor/core';
import { isPhone } from './os';
import muvikaAttrs from '../attrs'

export const lockOrientation = () => {

  if(Capacitor.isNativePlatform()){
    if (window.screen) {
      if (window.screen.orientation) {
        if (window.screen.orientation.lock) {
          if(checkIfMobile()){
            window.screen.orientation.lock("portrait");
          }else{
            window.screen.orientation.lock("landscape");
          }
        }
      }
    }
  }
};


export const checkIfMobile = () => {
  let isMobile = sessionStorage.getItem(muvikaAttrs.service+"-mobile");
  if(isMobile!==null){
    return JSON.parse(isMobile);
  }
  return isPhone();
};

/*

if (window.screen) {
    if (window.screen.orientation) {
      let ori = window.screen.orientation.angle;
      if (((ori == 90 || ori == -90) && window.screen.availWidth < 967) ||
        ((ori == 0 && window.screen.availWidth < 967))) {
        return true;
      } else {
        return false;
      }
    }
  }
};

*/